// src/sections/HalfForm.jsx
import React, { useState, useEffect, useMemo } from "react";
import CarForm from "../components/Form/Contatti";

export default function HalfForm({ contenuti }) {
  // Hook per il controllo del mobile
  const isMobile = useIsMobile();

  // Normalizza, split del titolo, individua le sezioni form e ordina
  const formattedContents = useMemo(() => {
    const arr = Array.isArray(contenuti) ? contenuti : Object.values(contenuti);
    return arr
      .map((item) => {
        // split del titolo su "|"
        const rawLines = item.titolo_it
          ? item.titolo_it.split("|").map((s) => s.trim())
          : [""];
        // è una sezione form se la prima linea è "Form" e c'è davvero tema.form
        const isFormSection =
          rawLines[0] === "Form" &&
          Array.isArray(item.tema?.form) &&
          item.tema.form.length > 0;
        // rimuovo "Form" dalle righe se è form section
        const titoloLines = isFormSection ? rawLines.slice(1) : rawLines;
        return {
          ...item,
          isFormSection,
          titoloLines,
          customClass: item.tema?.classiCustom || "",
        };
      })
      .sort((a, b) => Number(a.ordine) - Number(b.ordine));
  }, [contenuti]);

  // divido in due sotto-array, uno per la colonna di sinistra e uno per il form
  const leftItems = formattedContents.filter((i) => !i.isFormSection);
  const rightItems = formattedContents.filter((i) => i.isFormSection);

  console.log(leftItems);

  return (
    <section>
      <div className="container my-5 py-5 ">
        <div className="row">
          {/* COLONNA SINISTRA */}
          <div className=" col-12 col-md-6">
            {leftItems.map((item, idx) => (
              <div key={idx} className="mb-4">
                {item.customClass ? (
                  <a  target='_blank' className="text-black" href={item.link_it}> 
                    <div className={`d-flex align-items-center`}>
                    <i className={item.customClass} aria-hidden="true" />
                    <span className="ms-2 medium">{item.sottotitolo_it}</span>
                  </div>
                  </a>
                ) : (
                  <>
                    {item.titoloLines.map((line, i) => (
                      <h2
                        key={i}
                        className={
                          i === 0
                            ? "title-section"
                            : "green-medium title-section"
                        }
                      >
                        {line}
                      </h2>
                    ))}
                    {item.descrizione_it && (
                      <div
                        className="medium"
                        dangerouslySetInnerHTML={{
                          __html: item.descrizione_it,
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            ))}
          </div>

          {/* COLONNA DESTRA */}
          <div className="col-12 col-md-6">
            {rightItems.map((item, idx) => (
              <CarForm
                key={idx}
                formConfig={item.tema.form}
                apiEndpoint={item.tema.api}
                task={item.tema.task}
                isMobile={isMobile}
                submit={item.call_to_action_it || ""}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// custom hook riusabile per gestire la media query del breakpoint
function useIsMobile(breakpoint = 992) {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
}
